export default __webpack_public_path__ + "media/zurb/img/playground/stack-of-money-image-7ce635fac86bdef5d6e821903ce3c78c.png";